import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Folder, Compass } from './Icons';

function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="bottom-nav" aria-label="Main navigation">
      <button
        className={`bn-item${pathname === '/library' ? ' bn-active' : ''}`}
        onClick={() => navigate('/library')}
        aria-label="Library"
        aria-current={pathname === '/library' ? 'page' : undefined}
      >
        <Folder size={22} />
        <span>Library</span>
      </button>
      <button
        className={`bn-item${pathname === '/explore' ? ' bn-active' : ''}`}
        onClick={() => navigate('/explore')}
        aria-label="Explore"
        aria-current={pathname === '/explore' ? 'page' : undefined}
      >
        <Compass size={22} />
        <span>Explore</span>
      </button>
    </nav>
  );
}

export default BottomNav;
